import { z } from 'zod';
export const ReleaseStatusSchema = z.enum(['draft', 'published', 'deprecated', 'recalled']);
export const RolloutRingSchema = z.enum(['internal', 'pilot', 'general', 'canary', 'stable']);
export const ReleaseChannelSchema = z.enum(['stable', 'rc', 'hotfix']);
export const ReleaseArtifactSchema = z.object({
    id: z.uuid(),
    component: z.string(),
    artifactName: z.string(),
    imageDigest: z.string(),
    sha256Checksum: z.string(),
    signatureMetadata: z.record(z.string(), z.unknown()).optional(),
});
export const ReleaseSchema = z.object({
    id: z.uuid(),
    version: z.string(),
    channel: ReleaseChannelSchema.default('stable'),
    status: ReleaseStatusSchema.default('draft'),
    title: z.string(),
    releaseNotes: z.string(),
    breakingChanges: z.array(z.string()).default([]),
    minCompatibleVersion: z.string().default('v4.0.0'),
    migrationRequired: z.boolean().default(false),
    migrationNotes: z.string().nullable().optional(),
    artifacts: z.array(ReleaseArtifactSchema).default([]),
    publishedAt: z.iso.datetime().nullable().optional(),
    publishedByUserId: z.string().nullable().optional(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    versionNumber: z.number().int().default(1),
});
export const CampaignStatusSchema = z.enum([
    'draft',
    'scheduled',
    'in_progress',
    'paused',
    'completed',
    'rolled_back',
    'aborted',
]);
export const HealthGateCriteriaSchema = z.object({
    maxErrorRatePercent: z.number().min(0).max(100).default(1.0),
    minHealthyHeartbeatsPercent: z.number().min(0).max(100).default(95.0),
    maxDegradedComponents: z.number().int().nonnegative().default(0),
    autoRollbackOnFailure: z.boolean().default(true),
});
export const RolloutCampaignSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    releaseId: z.uuid(),
    releaseVersion: z.string(),
    targetRing: RolloutRingSchema,
    status: CampaignStatusSchema,
    healthGate: HealthGateCriteriaSchema,
    targetInstallationsCount: z.number().int().nonnegative().default(0),
    updatedInstallationsCount: z.number().int().nonnegative().default(0),
    failedInstallationsCount: z.number().int().nonnegative().default(0),
    scheduledWindowStart: z.iso.datetime().nullable().optional(),
    scheduledWindowEnd: z.iso.datetime().nullable().optional(),
    pausedReason: z.string().nullable().optional(),
    rollbackReason: z.string().nullable().optional(),
    initiatedByUserId: z.string(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    version: z.number().int().default(1),
});
export const CampaignInstallationStatusSchema = z.enum([
    'pending',
    'dispatched',
    'in_progress',
    'verified',
    'failed',
    'rolled_back',
]);
export const CampaignInstallationSchema = z.object({
    id: z.uuid(),
    campaignId: z.uuid(),
    installationId: z.string(),
    installationName: z.string().optional(),
    rolloutRing: RolloutRingSchema,
    status: CampaignInstallationStatusSchema,
    dispatchedAt: z.iso.datetime().nullable().optional(),
    acknowledgedAt: z.iso.datetime().nullable().optional(),
    verifiedAt: z.iso.datetime().nullable().optional(),
    errorMessage: z.string().nullable().optional(),
});
export const CreateReleaseRequestSchema = z.object({
    version: z.string().min(2).max(32),
    channel: ReleaseChannelSchema.default('stable'),
    title: z.string().min(3).max(120),
    releaseNotes: z.string().min(5),
    breakingChanges: z.array(z.string()).default([]),
    minCompatibleVersion: z.string().default('v4.0.0'),
    migrationRequired: z.boolean().default(false),
    migrationNotes: z.string().optional(),
    artifacts: z
        .array(z.object({
        component: z.string(),
        artifactName: z.string(),
        imageDigest: z.string(),
        sha256Checksum: z.string(),
    }))
        .default([]),
});
export const CreateCampaignRequestSchema = z.object({
    name: z.string().min(3).max(120),
    releaseId: z.uuid(),
    targetRing: RolloutRingSchema,
    healthGate: HealthGateCriteriaSchema.optional(),
    scheduledWindowStart: z.iso.datetime().optional(),
    scheduledWindowEnd: z.iso.datetime().optional(),
    installationIds: z.array(z.string()).optional(),
});
//# sourceMappingURL=releases.js.map